import service from '@/plugins/service'

const base = 'auth/organization'

export const getOrganizationList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const getOrganization = id => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      id,
      version: 3
    }
  })
}

export const searchOrganizationList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addOrganization = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const updateOrganization = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const removeOrganization = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}
